export default __webpack_public_path__ + "static/media/badge6-1.80f8ece6.png";